















import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import Project from '@/models/Project';
import ProjectServer from '@/models/ProjectServer';
import Mutations from '@/store/mutations';
import { EllipseCurve } from 'three';
import UserGroup from '@/models/UserGroup';
import User from '@/models/User';
import UserInfoController from '@/controllers/UserInfo'
import { UserQuestions } from '@/controllers/models/UserInfo';
import { BvModalEvent } from 'bootstrap-vue';
import DemographicQuestionsForm from './DemographicQuestionsForm.vue'

@Component({
    components: {
        DemographicQuestionsForm
    }
})
export default class DemographicQuestionsPopup extends Vue
{
    questions : UserQuestions | null = null;
    displayingForm = false;
    dontAskAgain = false;

    @Watch("user")
    onUserChanged(val: User, oldVal: User)
    {
        if (oldVal !== null) return;
        this.refresh();
    }

    mounted()
    {
        this.refresh();
    }

    async okClicked(evt : BvModalEvent)
    {
        evt.preventDefault();
        if (this.displayingForm)
        {
            const form = this.$refs.form as DemographicQuestionsForm;
            if (!form) return;
            try
            {
                if (!await form.submit())
                {
                    return;
                }
            }
            catch(err)
            {
                // TODO: Display error
                alert(err);
                return;
            }
        }
        else
        {
            this.displayingForm = true;
            return;
        }
        this.$bvToast.toast("Thanks! You can change your answers at any point on your Profile page.", { variant: "success" });
        (this.$refs.popupModal as any).hide();
    }

    async cancelClicked()
    {
        const questions = new UserQuestions;
        questions.affiliation = '';
        questions.role = '';
        questions.country = '';
        questions.state = '';

        if (this.dontAskAgain)
        {
            await UserInfoController.SetUserQuestions(questions);
            this.$bvToast.toast("You can answer the additional registration questions on your Profile page at any time.", { variant: "primary" })
        }
        else
        {
            this.$bvToast.toast("Okay, we'll check in again next time you use ClioVis. Or you can answer the questions in your Profile.", { variant: "primary" })
        }
    }

    async refresh()
    {
        if (this.user == null) return;
        try
        {
            this.$set(this, "questions", await UserInfoController.GetUserQuestions());
        }
        catch(err)
        {
            console.error(err);
            // TODO: Notify of failure
        }
        
        if (!this.questions)
        {
            // TODO: Display modal
            (this.$refs.popupModal as any).show();
        }
    }
}
